import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Fold Web Agency</h4>
            <p className="body-small mb-4">
              Creation de sites internet pour les professionnels
            </p>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <Link to="/creation-site-wordpress">Creation site WordPress</Link>
            <Link to="/creation-site-vitrine">Creation site vitrine</Link>
            <Link to="/referencement-seo">Referencement SEO</Link>
            <Link to="/maintenance-wordpress">Maintenance WordPress</Link>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <a href="mailto:contact@fold-web-agency.fr">contact@fold-web-agency.fr</a>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/politique-de-confidentialite">Politique de confidentialite</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Fold Web Agency. Tous droits reserves.
          </p>
        </div>
      </div>
    </footer>
  );
}
